import * as React from 'react';
import { MapContext } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';

export interface Events {
  [event: string]: (e: any) => any;
}

const { useContext, useEffect, useState } = React;

export interface CircleProps {
  center: any;
  radius: any;
  circleOptions?: {
    // path: any; // AMap.LocationValue[] | AMap.LocationValue[][] | undefined;
    [option: string]: any;
  };
  events?: Events;
}

function Circle(props: CircleProps): any {
  const { center, radius, circleOptions, events } = props;
  const map = useContext(MapContext);
  const [circle, setCircle]: [any, any] = useState(null);

  useBindEvents(circle, events);

  useEffect(() => {

    if (!map) {
      return;
    }
    const newCircle = new AMap.Circle({
      center: new AMap.LngLat(center[0], center[1]),
      radius,
      ...props.circleOptions,
    });
    (map as unknown as AMap.Map).add(newCircle);
    (map as unknown as AMap.Map).setFitView();

    setCircle(newCircle);
    
    return () => {
      (map as unknown as AMap.Map).remove(newCircle);
    };
  }, [map, circleOptions]);

  return null;
}

export default Circle;
